import { UseMutationResult, UseQueryResult } from 'react-query';

import { AxiosErrorDto, SuccessDto, GetResponseDto } from 'types/axios';
import { ImageDto } from 'types/api';
import { RoomDto } from 'hooks/room';
import { string } from 'yup/lib/locale';
// import { GetResponseDto } from 'types/axios';

export type DeviceDto = {
  type: DeviceType;
  onOff?: boolean;
  serialNumber?: string;
  slaveId?: number;
  isCompleted?: boolean;
  images: ImageDto[];
  vendorId?: number;
  schoolId?: number;
  classroomId?: number;
  gatewayId?: number;
};

export enum DeviceType {
  SCHOOL_METER = 'school_total_meter',
  AIR_CONDITIONER_TOTAL_METER = 'ac_total_meter',
  PV_METER = 'pv_total_meter',
  METER = 'class_meter',
  DONGLE = 'dongle',
  CARD_READER = 'card_reader',
  GATEWAY = 'gateway',
  IPC = 'ipc',
  SWITCH = 'switch',
  DASHBOARD = 'dashboard',
  TOTAL_METER = 'total_meter',
  AVM = 'deposit_system',
  ROUTER = 'router',
  PM25 = 'pm25',
  ROOM = 'room',
}

export type CalculateDevicesCompleteNumberFunc = (room: RoomDto) => {
  isDeployedNumber: number;
  totalDevicesCount: number;
  rate: string;
  status: 'normal' | 'default';
};

// delete
export type DeleteDevicePayload = { deviceId: number; schoolId: number };
export type DeleteDeviceFunc = (payload: DeleteDevicePayload) => Promise<SuccessDto<object>>;

export type DropdownDto = { id: string; name: string };
export type GetDropdownFunc = () => Promise<GetResponseDto<DropdownDto[]>>;

export type UseDeviceRto = {
  deviceDeleteMutation: UseMutationResult<SuccessDto<object>, AxiosErrorDto, DeleteDevicePayload>;
};
